// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../reason/clients/components/Labels.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var UTCDate = require("../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var OwnRentalNeedStatusLabel_rentalNeedV5_graphql = require("../../__generated__/OwnRentalNeedStatusLabel_rentalNeedV5_graphql.bs.js");

var convertFragment = OwnRentalNeedStatusLabel_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(OwnRentalNeedStatusLabel_rentalNeedV5_graphql.node, convertFragment, fRef);
}

var RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function OwnRentalNeedStatusLabel$WithoutErrorBoundary(props) {
  var match = use(props.rentalNeed);
  var status = match.status;
  switch (status.__typename) {
    case "ActiveRentalNeed" :
        if (!status.isRenewable) {
          return JsxRuntime.jsx(Labels.ActiveStatusLabel.make, {});
        }
        var daysLeft = DateFns.differenceInCalendarDays(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(status.activeUntil)), new Date());
        return JsxRuntime.jsx(Labels.ExpiringStatusLabel.make, {
                    expiringIn: Labels.stringOfExpiring(daysLeft)
                  });
    case "ExpiredRentalNeed" :
        return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "RentedRentalNeed" :
        return JsxRuntime.jsx(Labels.RentedLabel.make, {});
    case "WithdrawnRentalNeed" :
        return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
        return null;
    
  }
}

var WithoutErrorBoundary = {
  make: OwnRentalNeedStatusLabel$WithoutErrorBoundary
};

function OwnRentalNeedStatusLabel(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "rentalNeed status",
              children: JsxRuntime.jsx(OwnRentalNeedStatusLabel$WithoutErrorBoundary, {
                    rentalNeed: props.rentalNeed
                  })
            });
}

var make = OwnRentalNeedStatusLabel;

exports.RentalNeedFragment = RentalNeedFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
